import { useFullListingData } from '../listing'

import { useBrandingQuery } from './queries'

// Hooks
import { useBuyerSettings } from '../buyerSettings'

// Constants
import { REA, LO } from '../../constants/customerProfile'
import { OWNER_TYPES, RENTER_TYPES } from '../../constants/buyerSettings'

// Grabbing the pertinent info optimistically from our useBrandingQuery (useQuery) hook
export const useBranding = () => {
  const { address } = useFullListingData() ?? {}
  const { data, refetch, isError, isFetched } = useBrandingQuery(address) ?? {}
  const { customerProfile: customer, sponsor, branding } = data ?? {}

  const customerType = customer?.type
  const isSponsorPresent = Boolean(sponsor)

  const isSoloRea = () => {
    if (customer?.type === LO) {
      return false
    }

    return customerType === REA && !isSponsorPresent
  }

  return {
    // customer fields
    customerType,
    customerFirstName: customer?.firstName,
    customerLastName: customer?.lastName,
    customerFullName:
      customer?.firstName && customer?.lastName
        ? `${customer?.firstName} ${customer?.lastName}`
        : null,
    customerEmail: customer?.email,
    customerPhone: customer?.phone,
    customerNMLS: customer?.nmls,
    customerPhotoUri: customer?.photo,
    customerStatement: customer?.brandingStatement,
    customerCorporateName: customer?.corporateProfileName,
    customerCorporatePhone: customer?.corporateProfilePhone,

    // sponsor fields
    sponsorType: sponsor?.type,
    sponsorFirstName: sponsor?.firstName,
    sponsorLastName: sponsor?.lastName,
    sponsorFullName:
      sponsor?.firstName && sponsor?.lastName
        ? `${sponsor?.firstName} ${sponsor?.lastName}`
        : null,
    sponsorEmail: sponsor?.email,
    sponsorPhone: sponsor?.phone,
    sponsorNMLS: sponsor?.nmls,
    sponsorPhotoUri: sponsor?.photo,
    sponsorStatement: sponsor?.brandingStatement,
    sponsorCorporateName: sponsor?.corporateProfileName,
    sponsorCorporatePhone: sponsor?.corporateProfilePhone,
    isSponsorPresent,

    // branding fields
    loClientsHelped: branding?.loanOfficerClientsHelped,
    loYearsInIndustry: branding?.loanOfficerYearsInIndustry,

    // Computed Field
    isSoloRea: isSoloRea(),

    // misc
    refetch,
    isError,
    isFetched,
    isLoading: !isError && !isFetched,
  }
}

export const useIsOwner = () => {
  const { clientType } = useBuyerSettings()

  return OWNER_TYPES.includes(clientType)
}

export const useIsRenter = () => {
  const { clientType } = useBuyerSettings()

  return RENTER_TYPES.includes(clientType)
}
